import classNames from 'classnames';

export const HorizontalSeparator = ({ className, colorClassName }: { className?: string; colorClassName?: string }) => {
  const classes = classNames(
    `h-1.5px`,
    {
      'bg-gradient-to-r from-gray-gallery-darker via-gray-concrete to-white': !colorClassName,
    },
    className,
    colorClassName,
  );

  return <div className={classes} />;
};
